require('./partners.js');